<template>
  <div class="pdf-file">
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-100">
            <div class="media">
              <img :src="examInfo.picture_path ? examInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
              <div class="media-body">
                <h5>{{examInfo.class_user_name}}  <span class="badge rose align-middle">{{examInfo.cate_path}}</span></h5>
                <p><span class="gray">클래스</span> <strong>{{examInfo.class_name}}</strong></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-tabs ref="gradeTab" class="grade-tab" v-model="activeTabName" @tab-click="handlerTabClick">
      <el-tab-pane name="tab-grade">
        <span slot="label" class="gray label">채점표</span>
        <R010100 :is-report="true"></R010100>
      </el-tab-pane>

      <el-tab-pane name="tab-personal" v-if="examInfo.exam_paper_type !== 'NOTE' && (examInfo.stat === 'C' || examInfo.stat === 'O' && examInfo.close_yn === 'Y') ">
        <span slot="label" class="gray label">성적표</span>
        <div class="print-grade-personal">
          <div class="card second-card">
            <div class="card-body">
              <div class="d-flex blue-gray">
                <div class="p-2">
                  <h1 class="title">{{examInfo.exam_title}}</h1>
                  <p><span class="gray">시험일자</span> {{examInfo.open_dt}}</p>
                </div>
                <div class="p-2 ml-auto rank text-nowrap rank-text">
                  <div>
                    <span class="number"><strong>{{examInfo.exam_rank}}</strong></span> / <span class="numbe1">{{examInfo.entry_cnt}}</span>
                    <p class="center">석차</p>
                  </div>
                </div>
              </div>

              <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 분석</h2>
                      </div>
                      <div class="p-2 ml-auto text-nowrap">
                        <button type="button" class="btn btn-primary btn-scroll" :disabled="!isScrollLeft" @click="scrollTable(0)">&lt;</button>
                        <button type="button" class="btn btn-primary btn-scroll" :disabled="!isScrollRight" @click="scrollTable(1)">&gt;</button>
                      </div>
                    </div>
                    <data-tables ref="tabGroupTable" :data="groupData" :table-props="tableProps" :pagination-props="emptyPaginationProps" :page-size="emptyPageSize" v-loading="searchLoading">
                      <el-table-column v-for="(column, index) in groupColumns" :key="'row_' + index" header-align="center"
                        :prop="column.prop" :label="column.label" :align="column.align" :min-width="column.width" :label-class-name="'stone-table-label '" :class-name="'stone-table-cell ' + column.class" :formatter="column.formatter">
                        <template slot-scope="scope">
                          <span class="number">{{ scope.row[column.prop] }}</span><br />
                          <span class="number" v-if="column.prop !== 'cate_code_name'">{{ `(${scope.row[column.prop + '_100']})` }}</span>
                        </template>
                      </el-table-column>
                    </data-tables>
                    <!-- <stone-data-table
                      ref="tabGroupTable"
                      :loading="searchLoading"
                      :columns="groupColumns"
                      :data="groupData"
                      :table-props="tableProps"
                      :page-size="emptyPageSize"
                      :pagination-props="emptyPaginationProps">
                    </stone-data-table> -->
                  </fieldset>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>영역별 성적 비교</h2>
                      </div>
                      <div class="p-2 ml-auto">
                      <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <bar-chart :chart-data="barChartData" :height="barChartHeight" :options="barChartOptions" :styles="barChartStyles"></bar-chart>
                  </fieldset>
                </el-col>
              </el-row>

              <template v-if="graphVisible">
                <el-row :gutter="40">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <fieldset v-if="lineVisible">
                      <div class="d-flex">
                        <div class="p-2">
                          <h2>성적 변화 그래프</h2>
                        </div>
                        <div class="p-2 ml-auto">
                        <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                        </div>
                      </div>
                      <line-chart :chart-data="lineChartData" :height="lineChartHeight" :options="lineChartOptions" :styles="lineChartStyles"></line-chart>
                    </fieldset>
                    <fieldset v-if="radarVisible">
                      <div class="d-flex">
                        <div class="p-2">
                          <!-- <h2>영역별 누적 분석</h2> -->
                        </div>
                        <div class="p-2 ml-auto">
                        <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                        </div>
                      </div>
                      <radar-chart :chart-data="radarChartData" :height="radarChartHeight" :options="radarChartOptions" :styles="radarChartStyles"></radar-chart>
                    </fieldset>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <fieldset>
                      <div class="d-flex">
                        <div class="p-2">
                          <h2>취약유형 분석</h2>
                        </div>
                        <div class="p-2">
                          <strong><span class="number mint"></span></strong>
                        </div>
                      </div>
                      <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                          <colgroup>
                            <col width="15%" />
                            <col width="20%" />
                            <col width="65%" />
                          </colgroup>
                          <tr v-for="(quiz, idx) in quizWrongData" :key="'tr_' + idx">
                            <td class="is-center stone-table-cell"><div class="cell">{{idx + 1}}</div></td>
                            <td class="is-center stone-table-cell"><div class="cell">{{quiz.group_name}}</div></td>
                            <td class="stone-table-cell"><div class="cell">{{quiz.cate_path}}</div></td>
                          </tr>
                        </table>
                      </div>
                    </fieldset>
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <fieldset>
                  <div class="d-flex">
                    <div class="p-2">
                      <h2>취약유형 분석</h2>
                    </div>
                    <div class="p-2">
                      <strong><span class="number mint"></span></strong>
                    </div>
                  </div>
                  <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                      <colgroup>
                        <col width="15%" />
                        <col width="20%" />
                        <col width="65%" />
                      </colgroup>
                      <tr v-for="(quiz, idx) in quizWrongData" :key="'tr_' + idx">
                        <td class="is-center stone-table-cell"><div class="cell">{{idx + 1}}</div></td>
                        <td class="is-center stone-table-cell"><div class="cell">{{quiz.group_name}}</div></td>
                        <td class="stone-table-cell"><div class="cell">{{quiz.cate_path}}</div></td>
                      </tr>
                    </table>
                  </div>
                </fieldset>
              </template>

            </div>

          </div>

        </div>

        <div class="print-grade-personal">

          <div class="card second-card">

            <div class="card-body">

              <fieldset>
                <div class="d-flex">
                  <div class="p-2">
                    <h2>문항 분석</h2>
                  </div>
                  <div class="p-2">
                    <strong><span class="number mint"></span></strong>
                  </div>
                </div>
                <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                  <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                    <template v-for="t in quizSplitCount">
                        <thead :key="'th_1_' + t" class="has-gutter">
                        <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * itemCount">
                          <th class="is-center stone-table-cell stone-table-label">문항</th>
                          <th v-for="i in itemCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                            <span class="number" v-if="quizData[idx]">{{quizData[idx].display_no}}</span>
                          </th>
                        </tr>
                        </thead>
                        <tr :key="'tr_2_' + t">
                          <th class="is-center stone-table-cell stone-table-label">채점표</th>
                          <td v-for="i in itemCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionClassName(quizData[idx].solution_yn)">{{getSolutionName(quizData[idx].solution_yn)}}</span>
                          </td>
                        </tr>
                        <tr :key="'tr_3_' + t">
                          <th class="is-center stone-table-cell stone-table-label">정답률</th>
                          <td v-for="i in itemCount" :key="'td_3_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionRateClassName(quizData[idx].solution_yn)">{{formatterPrecision(quizData[idx].solution_rate)}}</span>
                          </td>
                        </tr>
                        <tr :key="'tr_4_' + t">
                          <th class="is-center stone-table-cell stone-table-label">영역</th>
                          <td v-for="i in itemCount" :key="'td_4_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionRateClassName(quizData[idx].solution_yn)">{{quizData[idx].group_cate_code_name}}</span>
                          </td>
                        </tr>
                    </template>
                  </table>
                </div>
              </fieldset>

              <fieldset>
                <h2>선생님 의견</h2>
                <div v-html="replaceCarriageReturnToBr(examInfo.exam_comment)"></div>
              </fieldset>

            </div>

          </div>

        </div>

      </el-tab-pane>

    </el-tabs>

  </div>
</template>

<script>

import 'element-ui/lib/theme-chalk/display.css'
import common from '@/modules/common'
import grade from '@/modules/grade'
import R010100 from './R010100.vue'

export default {
  name: 'R010201',
  components: {R010100},
  mixins: [common.mixins, grade],
  props: {
    isPrint: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      printVisible: this.isPrint, //
      itemCount: 5,
      activeTabName: 'tab-grade',
      isScrollLeft: false,
      isScrollRight: true
    }
  },
  mounted () {
    this.handleWindowResize()
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
    if (this.$refs.tabGroupTable) {
      this.$refs.tabGroupTable.$refs.elTable.bodyWrapper.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleWindowResize () {
      if (this.printVisible) {
        this.itemCount = 20
      } else {
        const width = this.$el.clientWidth
        if (width < 768) {
          this.itemCount = 5
        } else if (width < 992) {
          this.itemCount = 10
        } else if (width < 1200) {
          this.itemCount = 15
        } else {
          this.itemCount = 20
        }
      }
      this.quizSplitCount = this.getQuizRows()
    },
    created () {
      if (this.$route.params) {
        this.param = {
          exam_seq: this.getToNumber(this.$route.params.exam_seq),
          class_seq: this.getToNumber(this.$route.params.class_seq),
          class_user_seq: this.getToNumber(this.$route.params.class_user_seq)
        }
        this.loadInfo()
        this.loadExamUserComment()
      }
    },
    loadExamUserComment () {
      common.axios.post('/grade/exam/user/comment', this.param)
        .then(response => {
          const result = response.data
          this.examInfo.exam_comment = result.exam_comment
          this.examInfo.exam_times_comment = result.exam_times_comment
        })
    },
    // 시험 정보 조회
    loadInfo () {
      // 시험 정보
      common.axios.post('/grade/exam/user', this.param)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
          // 오답노트이거나 종료되지 않은 시험은 채점표만 보여준다.
          if (result.exam_paper_type === 'NOTE' || (result.stat === 'O' && result.close_yn === 'N')) {
            // this.$refs.gradeTab.$el.children[0].children[0].children[0].children[0].children[1].style.width = '100%'
            this.$refs.gradeTab.$el.children[0].style.display = 'none'
            return
          }
          // 모의고사인 경우에만 스파이더 차트를 보여준다
          if (result.exam_paper_type === 'TEST') {
            // 커리큘럼이 없을 경우에는 스파이더 차트 크기를 늘려준다.
            if (result.curriculum_yn === 'N') {
              this.lineVisible = false
              this.radarChartHeight = 442
            } else {
              this.timesVisible = true
            }
          } else {
            this.radarVisible = false
            if (result.curriculum_yn === 'Y') {
              this.lineChartHeight = 418
              this.timesVisible = false
            } else {
              this.graphVisible = false
              // this.lineVisible = false
            }
          }
          // 개인 성적표
          this.loadExamGrade()
          // 성적 변화
          this.loadExamGradeChart()
        })
    },
    loadExamGradeChart () {
      // 종합 성적표
      common.axios.post('/grade/total/', this.param)
        .then(response => {
          const result = response.data
          // console.log('loadExamGradeTotal : ', result)
          this.lineChartData = this.getLineChartData(result.exam_total)
        })
    },
    handlerTabClick () {
      let tableRef = ''
      if (this.activeTabName === 'tab-personal') {
        tableRef = 'tabGroupTable'
      }
      this.$nextTick(() => {
        if (tableRef !== '') {
          if (tableRef === 'tabGroupTable') {
            this.$refs[tableRef].$refs.elTable.doLayout()
            this.$refs[tableRef].$refs.elTable.bodyWrapper.addEventListener('scroll', this.handleScroll)
          } else {
            if (this.$refs[tableRef].$refs.stoneDataTable) {
              this.$refs[tableRef].$refs.stoneDataTable.$refs.elTable.doLayout()
            }
            this.$refs[tableRef].$refs.elTable.bodyWrapper.removeEventListener('scroll', this.handleScroll)
          }
        }
      })
    },
    scrollTable (type) {
      const moveSize = 40
      if (type === 0) {
        // left
        this.$refs.tabGroupTable.$refs.elTable.bodyWrapper.scrollLeft -= moveSize
      } else {
        // right
        this.$refs.tabGroupTable.$refs.elTable.bodyWrapper.scrollLeft += moveSize
      }
      // this.isScrollLeft = this.$refs.tabGroupTable.$refs.elTable.bodyWrapper.scrollLeft !== 0
      this.handleScroll()
    },
    handleScroll () {
      const elem = this.$refs.tabGroupTable.$refs.elTable.bodyWrapper
      const newScrollLeft = elem.scrollLeft
      const width = elem.clientWidth
      const scrollWidth = elem.scrollWidth
      this.isScrollLeft = newScrollLeft !== 0
      this.isScrollRight = scrollWidth - newScrollLeft - width !== 0
    }
  }
}
</script>

<style>
  .grade-tab .el-tabs__item {
    width: 50%;
    text-align: center;
    height: 64px;
    line-height: 64px;
    padding: 0;
  }
  .grade-tab .el-tabs__header {
    padding: 4px 0;
    margin: 0;
  }
  .rank-text {
    margin-top: -14px;
    display: flex;
    justify-content: center; /* align horizontal */
    align-items: center; /* align vertical */
  }
</style>
<style scoped>
  .grade-tab .print-grade-answer {
    padding: 8px 0 0 0;
  }
  .grade-tab .print-grade-personal {
    padding: 8px 0 0 0;
  }
  .btn-scroll {
    width: 10px;
    height: 25px;
    padding-left: 18px;
    padding-right: 24px;
    margin-top: 16px !important;
    margin-left: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/R010201.vue